export default __webpack_public_path__ + "static/media/RedSea.bb9e3d24.jpg";